<template>
  <div
    class="bbp-date-choose"
    :class="[isNoClick && 'bbp-date-choose_no-click']"
  >
    <BBPDatePicker
      :class="[value && 'bbp-date-choose_hide']"
      :input="calendarSettings"
      :model="model"
      styleType="only-icon"
      @input="onChangeDate"
    />
    <i
      v-if="hover === row._id && value"
      class="bbp-icon-cross bbp-date-choose__icon"
      @click="onIconClick"
    />
  </div>
</template>

<script>

import moment from 'moment'
import {get} from 'lodash'
import BBPDatePicker from '@/components/Main/BBPForm/BBPDatePicker/BBPDatePicker'

export default {
  name: 'BBPDateChoose',
  components: {
    BBPDatePicker
  },
  props: {
    column: {
      type: Object,
      default: () => ({})
    },
    row: {
      type: Object,
      default: () => ({})
    },
    hover: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    isOpen: false
  }),
  computed: {
    value () {
      const { prop } = this.column
      return get(this.row, prop, '')
    },
    formatValue () {
      const { calendarSettings = {} } = this.column
      const { format } = calendarSettings
      return this.value ? moment(this.value).format(format) : null
    },
    calendarSettings () {
      const { calendarSettings } = this.column
      return calendarSettings
    },
    model () {
      const { prop } = this.column
      return {
        [prop]: this.value ? new Date(this.value) : null
      }
    },
    isNoClick () {
      const { isNoClick = false } = this.column
      return isNoClick
    }
  },
  methods: {
    onChangeDate (date) {
      if (date === null) return
      const same = new Date(this.value).getTime() === date.getTime()
      if (same) return
      const currentElem = {
        row: this.row,
        column: this.column,
        value: date,
        isUpdate: true
      }

      this.row[this.column.prop] = date
      this.$emit('updateProject', currentElem)
    },
    onIconClick () {
      const currentElem = {
        row: this.row,
        column: this.column,
        value: null,
        isUpdate: true
      }
      this.row[this.column.prop] = null
      this.$emit('updateProject', currentElem)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

  .bbp-date-choose {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    &_no-click {
      pointer-events: none;
    }

    &__icon {
      display: flex;
      color: $color-silver;
      cursor: pointer;
      position: absolute;
      right: 20px;
    }
  }

</style>

<style lang="scss">

  .bbp-date-choose_hide {

    .bbp-icon-calendar {
      display: none;
    }

    .bbp-date-picker-body__date {
      font-size: 13px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTable/BBPDateChoose/BBPDateChoose.vue